var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleTable',{attrs:{"formclass":"Factory/form","endpoint":"factories","aditionalColumns":_vm.headers,"inlineToggle":"","hideDelete":""}},[[_c('h1',[_vm._v("Fábricas")]),_c('v-divider',{staticClass:"mb-4"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }